export default class Pagetop {
  constructor() {
    this.pagetop = document.querySelector('.js-pagetop');
    this.footer = document.querySelector('footer, .l-footer, .c-footer');
    this.isScrolling = false;
    this.fadeoutOffset = 100; // フッター手前100pxでフェードアウト開始

    if (this.pagetop) {
      this.init();
    }
  }

  init() {
    this.addEventListeners();
    // 初期状態での位置チェック
    this.checkScrollPosition();
  }

  addEventListeners() {
    // スクロールイベントの監視（パフォーマンスを考慮してthrottleを使用）
    window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 16));

    // リサイズ時も再チェック
    window.addEventListener('resize', this.throttle(this.checkScrollPosition.bind(this), 250));
  }

  handleScroll() {
    if (!this.isScrolling) {
      this.isScrolling = true;
      requestAnimationFrame(() => {
        this.checkScrollPosition();
        this.isScrolling = false;
      });
    }
  }

  checkScrollPosition() {
    if (!this.pagetop) return;

    // フッターが存在しない場合は通常の表示制御のみ
    if (!this.footer) {
      this.handleNormalScroll();
      return;
    }

    // フッターとの重なりをチェック
    this.checkFooterOverlap();
  }

  handleNormalScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // ページの80%以上スクロールしたら表示
    const showThreshold = 0.8;
    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    if (scrollPercentage >= showThreshold) {
      this.pagetop.classList.add('is-visible');
    } else {
      this.pagetop.classList.remove('is-visible');
    }
  }

  checkFooterOverlap() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const windowBottom = scrollTop + windowHeight;

    // フッターの位置を取得
    const footerRect = this.footer.getBoundingClientRect();
    const footerTop = scrollTop + footerRect.top;

    // ページトップボタンの位置を取得
    const pagetopRect = this.pagetop.getBoundingClientRect();
    const pagetopBottom = scrollTop + pagetopRect.bottom;

    // フッター手前でフェードアウト開始
    const fadeoutStart = footerTop - this.fadeoutOffset;

    // ページトップボタンがフッター手前に来たらフェードアウト
    if (pagetopBottom >= fadeoutStart) {
      this.pagetop.classList.add('is-fadeout');
    } else {
      this.pagetop.classList.remove('is-fadeout');
    }

    // 通常の表示制御も併用
    this.handleNormalScroll();
  }

  // パフォーマンス向上のためのthrottle関数
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}
